import React from 'react';
import styled from 'styled-components';
import { toRem } from 'design';
import { Icon } from '../Icon';
import PaginationButton from './PaginationButton';

interface PaginationItemProps {
  previous?: boolean;
  next?: boolean;
  label?: string;
  isActive?: boolean;
  disabled?: boolean;
  isLoading?: boolean;
  onClick?: () => void;
  className?: string;
}

const PrevIcon = styled(Icon)`
  position: relative;
  right: ${toRem(-1)};
`;

const NextIcon = styled(Icon)`
  position: relative;
  left: ${toRem(1)};
`;

const PaginationItem: React.FC<PaginationItemProps> = ({ previous, next, label, isActive, isLoading, onClick, disabled, className, ...rest }) => {
  const disabledButton = disabled || label === '...';
  const handleClick = isActive ? undefined : onClick;
  return (
    <PaginationButton isActive={isActive} disabled={disabledButton} onClick={handleClick} isLoading={isLoading} className={className} {...rest}>
      {label && label}
      {previous && <PrevIcon icon="Previous" width={7} height={11} label="Previous" />}
      {next && <NextIcon icon="Next" width={7} height={11} label="Next" />}
    </PaginationButton>
  );
};

export default PaginationItem;
